<div class="content">
    <div class="content">
     <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 common_title">
          <h2>
            EDIT - ANIMAL GENERAL DETAIL
            </h2>
          <!--<p>Edit animal general detail</p>-->
          <!--<a (click)="backnavigate()"  class="back_to"><i class="fa fa-chevron-left" aria-hidden="true"></i>
           Back
          </a>-->
          </div>
      </div>
      <br>
       <form class="row">
        <div class="col-lg-4 col-md-6 col-sm-6">
            <label for="Species Name" >Animal Type</label>
            <div class="form-group">
              <input type="text" id="animaltype" name="animaltype"  class="form-control">
              </div>
           </div>
           <div class="col-lg-4 col-md-6 col-sm-6">
            <div class="form-group">
            <label for="Species Name">Species Name</label>
            <select id="Speciesname" name="Speciesname" class="selectpicker form-control" (change)="breedselectbyspecies($event)">
              <option selected disabled>Select species</option>
              <option *ngFor='let specieslist of speciesloaddata' [value]="specieslist.id">{{specieslist.name}}</option>
            </select>
            </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="form-group">
                <label for="Breed Name">Breed Name</label>
                <select id="BreedName" name="BreedName" class="selectpicker form-control">
                  <option selected disabled>Select Breeds</option>
                  <option *ngFor='let breedname of getspeciesvalue' [value]="breedname.id">{{breedname.name}}</option>
                </select>
                </div>
                </div>
       <div class="col-lg-4 col-md-6 col-sm-6">
        <div class="form-group">
            <label for="Breed Name">Gender</label>
            <select id="gender" name="gender" class="selectpicker form-control">
              <option>Male</option>
              <option>Female</option>
            </select>
            </div>
       </div>
       <div class="col-lg-4 col-md-6 col-sm-6">
        <label for="Species Name" >Age</label>
        <div class="form-group">
          <input type="text" name="Age" id="Age"  value="" class="form-control">
          </div>
       </div>
       <div class="col-lg-4 col-md-6 col-sm-6">
        <label for="Species Name" >Weight</label>
        <div class="form-group">
          <input type="text" name="Weight" id="Weight"  value="" class="form-control">
          </div>
       </div>
       <div class="col-lg-4 col-md-6 col-sm-6">
        <label for="Species Name" >Date Of Birth</label>
        <div class="form-group">
          <input type="date" name="birthdate" id="birthdate"  value="" class="form-control">
          </div>
       </div>
       <div class="col-lg-4 col-md-6 col-sm-6">
        <label for="Species Name" >Date Of Transfer</label>
        <div class="form-group">
          <input type="date" name="transferdate" id="transferdate"  value="" class="form-control">
          </div>
       </div>
       <div class="col-lg-4 col-md-6 col-sm-6">
        <label for="Species Name" >Date Of Purchase</label>
        <div class="form-group">
          <input type="date" name="purchasedate" id="purchasedate"  value="" class="form-control">
          </div>
       </div>
      
       <div class="col-lg-4 col-md-6 col-sm-6">
        <label for="Species Name" > Date Of Deletion</label>
        <div class="form-group">
          <input type="date" name="deletiondate" id="deletiondate"  value="" class="form-control">
          </div>
        </div>
       <div class="col-lg-12 col-md-12 col-sm-12 text-center">
        <button type="submit" class="btn btn-fill btn-primary mb-3"  (click)="AnimalGeneral()">Submit<div class="ripple-container"></div></button>
        <button  (click)="backnavigate()" class="btn btn-fill btn-default">Cancel<div class="ripple-container"></div></button>
        </div>
       </form>
      
     </div>
   </div>
  </div>
  
  